<template>
    <div>
      <el-card class="box-card" style="margin: 30px; padding: 20px;">
        <div style="display: flex;">
          <div style="width: 420px;">
            <div style="min-height: 800px; border-radius: 10px; border: 1px solid #ccc;">
              <el-carousel height="200px" indicator-position="outside">
                <el-carousel-item v-for="item in branddata" :key="item">
                  <div @click="showlink(item)" style="height:100%; width:100%;">
                    <el-image
                      :src="item.adurl"
                      style="height:100%; width:100%;"
                      fit="cover"></el-image>
                  </div>
                </el-carousel-item>
              </el-carousel>
              <div style="margin: 10px; padding: 15px; border: 1px dotted #d9d9d9; border-radius: 6px;">
                <el-row :gutter="20">
                  <el-col :span="6" v-for="item in kjrkdata" :key="item">
                    <div style="display: flex; margin-top: 10px; flex-direction: column; align-items: center; justify-content: center;">
                      <el-image
                        :src="item.scurl"
                        style="width: 64px;height: 64px;display: block;border: 1px dashed #d9d9d9; border-radius: 6px;"
                        fit="cover"></el-image>
                      <div style="margin-top: 10px;">{{item.scname}}</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div style="flex: 1;margin: 0 20px 0 40px;">
            <div style="padding: 0 0 20px 0;">
              <el-button type="primary" icon="el-icon-plus" v-on:click="addkjrk">添加快捷入口</el-button>
            </div>
            <div style="padding: 40px; border: 1px solid #d9d9d9; display: flex;justify-content: center;">
              <el-table
                stripe
                :data="kjrkdata"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                ref="multipleTable">
                <el-table-column
                  prop="ascindex"
                  label="次序">
                </el-table-column>
                <el-table-column
                  prop="scname"
                  label="快捷名称">
                </el-table-column>
                <el-table-column
                  label="快捷入口图">
                  <template slot-scope="scope">
                    <div v-if="scope.row.scurl">
                      <img :src="scope.row.scurl" class="avatarimg1">
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="scname"
                  label="入口名称">
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="80px"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="分配指向" placement="top-start">
                      <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="editkjrk(scope.$index, kjrkdata)"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除该快捷入口" placement="top-start">
                      <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="delkjrk(scope.$index, kjrkdata)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <el-dialog title="资料信息" :visible.sync="vis_addshortcutpanel">
                <div>
                  <el-row>
                    <el-col :span="12">
                      <el-form  label-width="150px">
                        <el-form-item label="显示次序">
                          <el-select v-model="shortcut" filterable placeholder="请选择显示次序">
                            <el-option
                              v-for="item in shortcutlist"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="快捷名称">
                          <el-input
                            placeholder="请输入快捷入口名称"
                            v-model="kjrkname"
                            clearable>
                          </el-input>
                        </el-form-item>
                        <el-form-item label="上传快捷入口图标" class="yyzz_upload">
                          <UpLoadFile ref="upfile" @upok="upok" :ifshowfile="ifshowfile" :ifupload="ifupload" :ifimg="ifimg" :curfilepath="curfilepath" :bucketpath="bucketpath"></UpLoadFile>
                        </el-form-item>
                        <el-col style="margin-top: 10px;">
                          <el-form-item label="快捷入口地址：" class="yyzz_upload">
                            <el-input v-model="shortcutpath" placeholder="自动获取快捷入口地址"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-form>
                    </el-col>
                    <el-col :span="12">
                      <el-form style="margin-left: 30px;" label-width="120px" label-position="left">
                        <el-form-item label="链接产品分类:" >
                          <el-tree
                            :data="gtypedatas"
                            ref="gt_tree_list"
                            highlight-current
                            @current-change="typechange"
                            current-node-key="id"
                            node-key="id"
                            :check-strictly = "true"
                            :expand-on-click-node="false"
                            default-expand-all
                            :render-content="renderugcontext"
                          />
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="24">
                      <el-button type="success" icon="el-icon-edit-outline" style="margin-top: 10px" @click="addnewshortcut">保存数据</el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-dialog>
            </div>
          </div>
        </div>
      </el-card>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import UpLoadFile from '../upload/UpLoadFile'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'KJRK',
    components: {
      UpLoadFile
    },
    data () {
      return {
        vis_addshortcutpanel: false,
        kjrkdata: [],
        kjrkname: '',
        bucketpath: 'ecomm/shortcut',
        ifshowfile:false, // 上传页面参数： 是否显示文件
        curfilepath: '', // 上传页面参数： 当前选中图标文件路径
        ifimg: true, // 上传页面参数： 上传方式是否设定为 图片模式
        ifupload: true, // 上传页面参数： 是否显示上传参数
        shortcutlist: [{
          value: '1',
          label: '1号位置'
        }, {
          value: '2',
          label: '2号位置'
        }, {
          value: '3',
          label: '3号位置'
        }, {
          value: '4',
          label: '4号位置'
        }, {
          value: '5',
          label: '5号位置'
        }, {
          value: '6',
          label: '6号位置'
        }, {
          value: '7',
          label: '7号位置'
        }, {
          value: '8',
          label: '8号位置'
        }],
        shortcut: '',
        upshortcutparams: '',
        gtypedatas: [],
        branddata: [],
        selecttype: '',
        select_type: '',
        editkjrkdata: '',
        khid: '',
        ifnew: true
      }
    },
    mounted () {
      that = this
      var v = getCookie('cusid')
      this.khid = v
      that.querykjrk()
      that.get_typedata()
      that.querybrand()
    },
    methods: {
      querybrand () {
        that = this
        if (that.khid === null) {
          that.$message({
            type: 'info',
            message: 'Cookie已失效，请重新登录!'
          })
          that.$router.push({path: '/'})
        } else {
          var qstr = {
            whereinfo: " ownphone ='" + localStorage.getItem('username') + "'",
            limit: '',
            sortinfo: ''
          }
          that.$http({
            url: 'https://ecommapi.sqnetsoft.cn/querylbi',
            method: 'post',
            data: qstr,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.length > 0) {
                that.branddata = res.data
              } else {
                that.branddata = []
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      },
      typechange (node) {
        window.console.log(node)
        that.select_type = node.name
        that.selecttype = node.id
      },
      upok (curpath,fileList) {
        that.shortcutpath = curpath
        window.console.log(fileList)
      },
      addnewshortcut () {
        if (this.selecttype !== '' && that.kjrkname !== '' && that.shortcutpath !== '') {
          var data = ''
          if (that.ifnew) {
            data = {
              id: '',
              scurl: that.shortcutpath,
              scname: that.kjrkname,
              ascindex: that.shortcut.toString(),
              link: this.selecttype.toString(),
              appid: '0',
              cusid: that.khid.toString(),
              ownphone: localStorage.getItem('username')
            }
          } else {
            data = {
              id: that.editkjrkdata.id.toString(),
              scurl: that.shortcutpath,
              scname: that.kjrkname,
              ascindex: that.shortcut.toString(),
              link: this.selecttype.toString(),
              appid: '0',
              cusid: that.khid.toString(),
              ownphone: localStorage.getItem('username')
            }
          }
          that.$http({
            url: 'https://ecommapi.sqnetsoft.cn/addkjrk',
            method: 'post',
            data: data,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.result === 'success') {
                that.$message({
                  type: 'success',
                  message: '保存完毕'
                })
                that.querykjrk()
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          that.$message.info('信息不完整')
        }
      },
      typeselectchange (row) {
        console.log(row)
        this.selecttype = row
        this.select_type = row.name
      },
      renderugcontext (h, { node, data, store }) {
        return (
          <div style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <div style="display: flex; flex-direction: row; align-items: center; height: 45px; width:100%; border-bottom:1px solid #f3f3f3;justify-content: space-between;">
          <div>
          {
          <span> {data.name} </span>
      }
      </div>
        </div>

        </div>
      )
      },
      get_typedata () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('username') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/quergtype',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.length > 0) {
              that.gtypedatas = JSON.parse(res.data[0].typetree)[0].children
            } else {
              that.gtypedatas = []
              var adata = {
                id: 0,
                name: '默认类别',
                imgurl: '',
                children: []
              }
              that.gtypedatas.push(adata)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querykjrk () {
        that = this
        if (that.khid === null) {
          that.$message({
            type: 'info',
            message: 'Cookie已失效，请重新登录!'
          })
          that.$router.push({path: '/'})
        } else {
          var qstr = {
            whereinfo: " ownphone ='" + localStorage.getItem('username') + "'",
            limit: '',
            sortinfo: ''
          }
          that.$http({
            url: 'https://ecommapi.sqnetsoft.cn/querykjrk',
            method: 'post',
            data: qstr,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.length > 0) {
                that.kjrkdata = res.data
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      },
      addkjrk () {
        this.ifnew = true
        this.vis_addshortcutpanel = true
      },
      delkjrk (index, data) {
        var curselectdata = data[index]
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/delkjrk',
          method: 'post',
          data: {
            id: curselectdata.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.querykjrk()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      editkjrk (index, data) {
        var curselectdata = data[index]
        that.ifnew = false
        that.vis_addshortcutpanel = true
        that.editkjrkdata = curselectdata
        that.shortcutpath = curselectdata.scurl
        that.curfilepath = curselectdata.scurl
        that.kjrkname = curselectdata.scname
        that.shortcut = curselectdata.ascindex.toString()
        window.console.log('数据',that.gtypedatas,curselectdata.link)
        var dataindex = that.gtypedatas.findIndex(d => d.id === parseInt(curselectdata.link))
        window.console.log('次序',dataindex)
        this.select_type = that.gtypedatas[dataindex].name
        this.selecttype = curselectdata.link
        setTimeout(() => {
          this.$refs.gt_tree_list.setCurrentNode(that.gtypedatas[dataindex])
        }, 0)
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/control/KJRK.vue